// src/admin/components/FooterControls.jsx
import React from 'react';
import PropTypes from 'prop-types';

/**
 * FooterControls
 * Handles Cancel/Back/Next or displays a hint instead of Next button.
 */
export default function FooterControls({
  step,
  totalSteps,
  bottomMessage,
  onCancel,
  onBack,
  onNext,
  nextHint,
  disableNext,
  backLabel,
  nextLabel,
}) {
  const isFirst = step === 1;

  return (
    <div className="d-flex justify-content-between w-100 align-items-center">
      <button
        type="button"
        className="btn btn-white"
        onClick={isFirst ? onCancel : onBack}
      >
        {backLabel || (isFirst ? 'Cancel' : 'Back')}
      </button>

      <div className="small text-muted">
        {bottomMessage || (totalSteps ? `Step ${step} of ${totalSteps}` : `Step ${step}`)}
      </div>

      {nextHint ? (
        <span className="text-muted small">{nextHint}</span>
      ) : (
        <button
          type="button"
          className="btn btn-primary"
          onClick={onNext}
          disabled={disableNext}
        >
          {nextLabel || 'Next'}
        </button>
      )}
    </div>
  );
}

FooterControls.propTypes = {
  step: PropTypes.number.isRequired,
  totalSteps: PropTypes.number,
  onCancel: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  nextHint: PropTypes.string,
  disableNext: PropTypes.bool,
  backLabel: PropTypes.string,
  nextLabel: PropTypes.string,
};

FooterControls.defaultProps = {
  totalSteps: null,
  nextHint: null,
  disableNext: false,
  backLabel: null,
  nextLabel: null,
};